<script setup lang="ts">
  import { ref } from 'vue';

  import { Popover, PopoverContent, PopoverTrigger } from '@ui/components/popover/index';

  const props = defineProps<{
    disabled?: boolean;
  }>();

  const emit = defineEmits<{
    opened: [];
  }>();

  const isOpen = ref(false);
  const openTimer = ref<NodeJS.Timeout | null>(null);
  const closeTimer = ref<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (props.disabled) return;

    if (closeTimer.value) {
      clearTimeout(closeTimer.value);
      closeTimer.value = null;
    }

    if (!isOpen.value && !openTimer.value) {
      openTimer.value = setTimeout(() => {
        isOpen.value = true;
        emit('opened');
        openTimer.value = null;
      }, 250);
    }
  };

  const handleMouseLeave = () => {
    if (openTimer.value) {
      clearTimeout(openTimer.value);
      openTimer.value = null;
    }

    closeTimer.value = setTimeout(() => {
      isOpen.value = false;
    }, 100);
  };
</script>

<template>
  <Popover :open="isOpen">
    <PopoverTrigger
      as-child
      :class="disabled && 'pointer-events-none text-muted-foreground '"
      class="cursor-default"
      @click.stop.prevent
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
      <slot name="trigger" />
    </PopoverTrigger>

    <PopoverContent class="w-fit p-3" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <slot name="content" />
    </PopoverContent>
  </Popover>
</template>
